/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:16]
Permissions to update outside the main branch: [false]
*/

import { AxiosInstance } from 'axios';
import { ScoringSettingsDto } from 'models/api/scoringSettings';

const controller = '/scoringsettings';

export const getScoringSettings = async (axios: AxiosInstance) => {
    const response = await axios.get<ScoringSettingsDto>(controller);
    return response.data;
};

export const changeScoringSettings = async (axios: AxiosInstance, item: ScoringSettingsDto) =>
    await axios.put<ScoringSettingsDto>(controller, item);
